export function pluralize(count: number, singular: string, plural = `${singular}s`): string {
  return `${count} ${count === 1 ? singular : plural}`;
}

export function firstLine(text: string, max = 140): string {
  const line = text.split('\n').find((part) => part.trim().length > 0)?.trim() ?? '';
  return line.length > max ? `${line.slice(0, max - 1)}…` : line;
}

export function channelLabel(channel: string): string {
  if (channel === 'web') return 'Web';
  if (channel === 'mcp') return 'MCP';
  if (channel === 'cli') return 'CLI';
  return channel;
}

export function originLabel(origin: string): string {
  if (origin === 'import') return 'Import';
  if (origin === 'upload') return 'Upload';
  if (origin === 'mcp') return 'MCP';
  return origin;
}

export function generationKindLabel(kind: string): string {
  if (kind === 'adhoc') return 'Generated';
  if (kind === 'event') return 'Event snapshot';
  if (kind === 'regenerated') return 'Regenerated from manifest';
  return kind;
}
